import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

interface AdviceRoomUpdatePrivateNotePatchOptions {
  privateNote?: string;
  sendToPracticeNotes?: boolean;
}

export function adviceRoomUpdatePrivateNoteApi(path: string) {
  return {
    path,
    PATCH: (params: AdviceRoomUpdatePrivateNotePatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
